/**
 *  Main Menu Json
 */
export default [
    {
        'menu_title': 'Home',
        'type': 'mainMenu',
        'path': '/',
        'fragment': 'home',
        'icon': 'home'
    },
    {
        'menu_title': 'About Us',
        'type': 'mainMenu',
        'path': '/',
        'fragment': 'about-us',
        'icon': 'party_mode'
    },
    {
        'menu_title': 'What We Do',
        'type': 'mainMenu',
        'path': '/',
        'fragment': 'what-we-do',
        'icon': 'home'
    },
    {
        'menu_title': 'Careers',
        'type': 'mainMenu',
        'path': '/careers',
        'icon': 'home'
    }
]
